export const FEEDBACK_MANY_FETCHED = 'FEEDBACK_MANY_FETCHED';
export const FEEDBACK_MANY_ADD = 'FEEDBACK_MANY_ADD';
